<div
    class="transition-[opacity, scale] absolute left-14 z-dropdown-menu rounded-xl bg-white px-8 py-4 shadow-2xl duration-150"
    [ngClass]="isHidden ? 'origin-top scale-y-0 opacity-0' : 'origin-top scale-y-100 opacity-100'"
>
    <div class="flex h-12 items-center justify-between border-0 gap-8 border-none font-bold text-primary">
        <div>{{ contentList[selectedIndex].name }}</div>
        <button class="icon-button" (click)="hide()" (keypress)="hide()">
            <fa-icon class="fa-lg text-primary" [icon]="closeIcon" size="xs"></fa-icon>
        </button>
    </div>

    @if (contentList.length > 5) {
        <div class="mb-4">
        <input appDebounce
            type="text"
            placeholder="Zoek organisaties..."
            [formControl]="searchControl"
            appDebounce
            (debounceEvent)="onDebouncedSearch($event)"
            class="input"
        />
        </div>
    }

    <ul class="m-0 max-h-[40vh] overflow-y-auto p-0">
        @for (item of displayList; track item.name; let index=$index ) {
            <li
                (click)="index !== displayedIndex && selectItem(item, index)"
                (keypress)="index !== displayedIndex && selectItem(item, index)"
                class="py-4 pl-0 pr-40 border-t-2 border-solid border-offwhite"
                [ngClass]="index === displayedIndex ? 'cursor-default text-body' : 'cursor-pointer text-primary hover:bg-offwhite'"
            >
                <span class="pl-2">{{ item.name }}</span>
            </li>
        }
    </ul>
</div>
